<div class="timeline__dot" [ngClass]="css"></div>
